<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Unmatch {{ title }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <!-- Informational only. Unmatch dissolves the whole group server-side, so there is nothing to
       pick here — the list says what is about to be detached. The count is disclosed only when the
       selection provably spans more than one group, and as a minimum: a member outside the loaded
       page is invisible from the client, so "at least" is the strongest claim available. -->
  <p class="hint" *ngIf="!multipleGroups">
    Unmatching dissolves the whole match group. These transactions will be
    detached and return to Unmatched.
  </p>
  <p class="hint" *ngIf="multipleGroups">
    Unmatching dissolves each whole match group — this will dissolve at least
    {{ groupCount }} match groups. These transactions will be detached and
    return to Unmatched.
  </p>
  <div *ngFor="let source of sources" class="source-row">
    <span class="dot" [style.background]="source.color"></span>
    <span class="label">{{ source.label }}</span>
    <span class="count">{{ source.count }}</span>
  </div>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button nf-button="danger" (click)="confirm()">Unmatch</button>
  </div>
</div>
